/**
 * Allows you to chain method calls to any object
 * @export
 * @param  {any} object 
 * @return {any}
 */
export default function Chain(object)
{
    return new Proxy(object, {
        get: (original, property, proxy) => {
            let value = original[property];
            
            if (typeof value === "function")
            {
                return function()
                {
                    value.apply(original, arguments);
                    return proxy;
                }
            }

            return value;
        }
    });
}